import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CountryPickerModule } from '../../../../shared/components/country-picker/country-picker.module';
import { SharedModule } from '../../../../shared/shared.module';
import { NewCountryDialogComponent } from './new-country-dialog.component';

@NgModule({
  declarations: [NewCountryDialogComponent],
  imports: [
    SharedModule,
    MatLabel,
    MatInputModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    CountryPickerModule,
    ReactiveFormsModule,
  ],
  exports: [NewCountryDialogComponent],
})
export class NewCountryDialogModule {}
